export default __webpack_public_path__ + "img/17ff398fc1151f6740d8303dffd2c9e9.svg";